













import { Component, Prop, Vue } from 'vue-property-decorator'
import CollapsibleSection from '@/components/Survey/CollapsibleSection.vue'
import { Icon } from '@alpha/ink'

@Component({
  components: {
    CollapsibleSection,
    Icon
  }
})
export default class CollapsibleSectionWithHeader extends Vue {
  @Prop({ required: false, default: true }) openInitially!: boolean
  @Prop({ required: false }) maxHeight!: string // '15rem'
  expanded = this.openInitially
}
